var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpotify = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 13.5,
    fill: "#1ED760"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.214 16.548c-4.075-2.435-10.798-2.659-14.688-1.47a1.181 1.181 0 01-1.475-.794A1.192 1.192 0 019.84 12.8c4.466-1.364 11.89-1.1 16.582 1.702.562.335.746 1.066.413 1.63a1.178 1.178 0 01-1.62.416zm-.133 3.607a.983.983 0 01-1.356.327c-3.398-2.101-8.579-2.71-12.599-1.482a.986.986 0 01-1.23-.661.994.994 0 01.657-1.237c4.592-1.402 10.3-.723 14.203 1.69.464.287.61.898.325 1.363zm-1.547 3.464a.784.784 0 01-1.084.264c-2.97-1.825-6.706-2.238-11.107-1.226a.787.787 0 01-.943-.597.792.792 0 01.592-.949c4.816-1.108 8.948-.631 12.28 1.418a.796.796 0 01.262 1.09z",
    fill: "#141413"
  })));
};
export default SvgSpotify;